import apiClient from '@/services/apiService';

class MediaService {
  async uploadMedia(files: File | File[], label: string): Promise<UploadResponse> {
    const formData = new FormData();

    // Handle single or multiple file uploads
    if (Array.isArray(files)) {
      files.forEach((file) => formData.append('files[]', file));
    } else {
      formData.append('file', files);
    }

    formData.append('label', label);

    try {
      const response = await apiClient.post<UploadResponse>('/upload-media', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const resData = response.data;

      // Normalize the backend response shape (for safety)
      if (Array.isArray(resData.data)) {
        // Multiple uploaded files
        return {
          ...resData,
          data: resData.data,
        };
      } else {
        // Single uploaded file
        return {
          ...resData,
          data: resData.data,
        };
      }
    } catch (error: any) {
      console.error('Error uploading file(s):', error);
      return {
        status: false,
        message: error.response?.data?.message || 'An error occurred while uploading the file(s).',
        data: Array.isArray(files)
          ? [] // if multiple, return empty array
          : {
              success: false,
              file_name: '',
              relative_path: '',
              label: '',
              preview_url: '',
            },
      };
    }
  }
}

export default new MediaService();
